import { useContext, useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { AuthContext } from "../../hoc/AuthContext";
import { getLoyaltyEditPath, LOYALTY_ADD_PATH } from "./constants";
import { getProgramId } from "./utils";
import { useProgramsList } from "./hooks/useProgramsList";
import EventsOrderModal from "./components/EventsOrderModal";
import ProgramsTable from "./components/ProgramsTable";

export default function LoyaltyProgram() {
  const navigate = useNavigate();
  const { selectedDomain } = useContext(AuthContext);
  const {
    programs,
    isLoading,
    error,
    actionError,
    isSavingOrder,
    togglingIds,
    handleSetProgramList,
    handleToggleStatus,
    saveProgramOrder,
  } = useProgramsList(selectedDomain?.id);
  const [eventsModal, setEventsModal] = useState({
    isOpen: false,
    programId: null,
    programTitle: "",
  });

  const openEventsModal = (program) => {
    const programId = getProgramId(program);
    if (!programId) return;
    setEventsModal({
      isOpen: true,
      programId,
      programTitle: program.title_en || "",
    });
  };

  return (
    <Layout>
      <main>
        <EventsOrderModal
          isOpen={eventsModal.isOpen}
          programId={eventsModal.programId}
          programTitle={eventsModal.programTitle}
          onClose={() => setEventsModal({ isOpen: false, programId: null, programTitle: "" })}
        />
        <div className="mx-auto max-w-7xl my-2 px-4 lg:px-0">
          <div className="bg-white rounded-2xl shadow-lg">
            <div className="mx-auto p-6 bg-slate-50 rounded-t-2xl">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <h1 className="text-2xl font-bold tracking-tight text-gray-900">Loyalty Program</h1>
                  <p className="mt-1 text-sm text-gray-600">
                    Manage loyalty program settings, rewards, and member activity.
                  </p>
                </div>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 rounded-xl bg-cyan-500 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-600"
                  onClick={() => navigate(LOYALTY_ADD_PATH)}
                >
                  <PlusIcon className="h-4 w-4" />
                  Add
                </button>
              </div>
            </div>
            {actionError ? <p className="px-6 pt-4 text-sm text-red-600">{actionError}</p> : null}
            {isSavingOrder ? (
              <p className="px-6 pt-4 text-sm text-cyan-700">Saving program order...</p>
            ) : null}
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-100">
                <thead className="bg-gray-50 text-left text-sm font-semibold text-gray-500">
                  <tr>
                    <th className="px-6 py-4">Sr No.</th>
                    <th className="px-6 py-4">Title</th>
                    <th className="px-6 py-4">Status</th>
                    <th className="px-6 py-4">Action</th>
                  </tr>
                </thead>
                <ProgramsTable
                  programs={programs}
                  isLoading={isLoading}
                  error={error}
                  isSavingOrder={isSavingOrder}
                  togglingIds={togglingIds}
                  onSetList={handleSetProgramList}
                  onReorderEnd={saveProgramOrder}
                  onToggleStatus={handleToggleStatus}
                  onOpenEvents={openEventsModal}
                  onEdit={(programId) => navigate(getLoyaltyEditPath(programId))}
                />
              </table>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}
